import { render, staticRenderFns } from "./YioksLoading.vue?vue&type=template&id=13321338&scoped=true&"
import script from "./YioksLoading.vue?vue&type=script&lang=js&"
export * from "./YioksLoading.vue?vue&type=script&lang=js&"
import style0 from "./YioksLoading.vue?vue&type=style&index=0&id=13321338&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13321338",
  null
  
)

export default component.exports